'use client';

/**
 * The header's Easy Read control, working on a single insight.
 *
 * THERE IS ONE EASY READ PER POST, AND IT IS THE SECTION ON THIS PAGE. Annette, 21 Oct 2026:
 * "there appears to be 2 lots of easy read for each insight - 1 accessed by the button in the
 * insight and one by the menu??? ... THERE ARE 2 LOTS OF EASY READS FOR INSIGHTS! IT IS NOT
 * CONSISTENT!" There were two, and both had been asked for:
 *
 *   - the link in the article to a labelled "Easy Read version" section lower down the same page
 *     (§4A R-24b, and it works with JavaScript off), and
 *   - this control, which rendered the post's Easy Read text A SECOND TIME in place of the
 *     article (added 20 Oct: "the easy read in the header also needs to go to the easy read
 *     insight"), at a different type size.
 *
 * So the standard page carried the whole Easy Read inline AND could render it again on demand.
 * This component no longer renders anything of its own: it takes the reader to the one section
 * that already exists, focuses it so a screen reader and the keyboard land there too, and leaves
 * the article standing.
 *
 * WHY NOT A PAGE OF ITS OWN, like the Easy Read privacy policy and website terms. Because
 * AXAI-SPEC-019 §4A R-24 (b) says the offer is "a clearly labelled section or switch ON THE SAME
 * URL", and a spec changes only on Annette's instruction (K1 §9). Moving it to
 * /insights/<slug>/easy-read was written and reverted on 21 Oct for that reason; it is the more
 * consistent shape and it is on the WR list as a question for her, not a change made on my reading
 * of "fix this up".
 */

import { useEffect, type ReactNode } from 'react';
import { easyRead } from '@/components/site/easyReadStore';
import { EASY_READ_ID } from './EasyRead';

export function PostEasyReadSwap({
  easyReadMd,
  children,
}: {
  /** The post's Easy Read markdown, or null when it has none. */
  easyReadMd: string | null;
  children: ReactNode;
}) {
  useEffect(() => {
    easyRead.restore();
    const goToSection = (on: boolean) => {
      if (!on || !easyReadMd) return;
      const section = document.getElementById(EASY_READ_ID);
      if (!section) return;
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // tabIndex={-1} on the section, so focus follows the scroll for keyboard and screen readers.
      section.focus({ preventScroll: true });
    };
    // Only on a CHANGE, never on load: arriving with the preference already on must not yank the
    // reader past the article they came for.
    return easyRead.subscribe(goToSection);
  }, [easyReadMd]);

  return <>{children}</>;
}
